import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

interface BungalowInfoTopProps {
    bannerVersion: string
}

export const BungalowInfoTop = styled(Box)<BungalowInfoTopProps>`
    min-width: 329px;
    background: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px 8px 0 0;
    position: relative;

    .max-people {
        position: absolute;
        top: -3px;
        right: 33px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
            margin: -3px auto;
            @media ${respondAbove.xl} {
                margin: -5px auto;
            }
            color: inherit;
        }
    }

    &::before {
        position: absolute;
        content: url(${(props) => props.bannerVersion});
        top: -6px;
        right: 16px;
    }

    .hasBorderBottom {
        border-bottom: 2px solid ${({ theme }) => theme.colors.grayscale_200};
        padding-bottom: 16px;
        margin-bottom: 8px;
    }
`

export const BungalowInfoBottom = styled(Box)`
    background: ${({ theme }) => theme.colors.grayscale_100};
    border-radius: 0 0 8px 8px;
`
